import { useParams } from "react-router-dom";
import ProjectShell from "../components/ProjectShell";
import DiaryTab from "../components/DiaryTab";

export default function ProjectDiary() {
  const { id } = useParams<{ id: string }>();

  return (
    <ProjectShell projectId={id!} activeTab="diary">
      <DiaryTab projectId={id!} />
    </ProjectShell>
  );
}
